import React, {Component, Fragment} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {Assignment, Person, PersonAdd} from '@material-ui/icons';
import i18n from '../i18n/i18n';
import {menuItem, menuItemIcon, menuItemText, menuItemTitle} from '../styles';

const styles = () => ({
});

class DrawerStudentItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            anchor: null
        };
    }

    handleClick = e => {
        this.setState({open: !this.state.open, anchor: e.currentTarget});
    };

    handleStudentCreateClick = () => {
        this.setState({open: false});
        this.props.onCreateStudentClick();
    };

    handleSubscriptionsClick = () => {
        this.setState({open: false});
        this.props.onSubscriptionsClick();
    };

    render() {
        return (
            <Fragment>
                <ListItem button onClick={this.handleClick} style={menuItem}>
                    <div style={menuItemTitle}>
                        <div style={menuItemIcon}>
                            <ListItemIcon><Person/></ListItemIcon>
                        </div>
                        <div style={menuItemText}>
                            <ListItemText primary={i18n.t('STUDENT_DRAWER_ITEM')}/>
                        </div>
                    </div>
                    <div style={{
                        display: this.state.open ? 'block' : 'none',
                    }}>
                        <List>
                            <ListItem button onClick={this.handleStudentCreateClick}>
                                <ListItemIcon style={{flex: 0.2}}><PersonAdd/></ListItemIcon>
                                <ListItemText style={{flex: 0.8}} primary={i18n.t('STUDENT_CREATION_TITLE')}/>
                            </ListItem>
                            <ListItem button onClick={this.handleSubscriptionsClick}>
                                <ListItemIcon><Assignment/></ListItemIcon>
                                <ListItemText primary={i18n.t('SUBSCRIPTION_OVERVIEW_TITLE')}/>
                            </ListItem>
                        </List>
                    </div>
                </ListItem>
            </Fragment>
        );
    }
}

export default withStyles(styles)(DrawerStudentItem);
